import { getWikiPage } from '../FrontServices/endpoints/wiki/wiki.api'
import { wikiIndexItemsMapper } from './help.mapper'
import { WikiIndexEntry } from './model'

type WikiPage = { path: string; content: string; subPages: WikiPage[] }

const ROOT_PAGE_PATH: string = '/'

const apiADOFetchWikiContent = async (contentPath: string): Promise<WikiPage> => {
  return await getWikiPage(contentPath)
}

export const apiFetchWikiIndex = async (): Promise<WikiIndexEntry | undefined> => {
  let wikiIndex: WikiIndexEntry
  try {
    const response = await apiADOFetchWikiContent(ROOT_PAGE_PATH)
    wikiIndex = wikiIndexItemsMapper(response)
    return wikiIndex
  } catch (error) {
    console.log('error', error)
    return undefined
  }
}

export const apiFetchHelpContent = async (path: string): Promise<string> => {
  const page = await apiADOFetchWikiContent(path)

  return page?.content
}
